import React from "react";

import { Box, Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { handleGetConvertValue } from "../../../../../util/converts";
import { getWeightMeasurement } from "../../../../../util/getMeasurement";
import { ProgressBarContainerEvent } from "../../../index";
import { LocationIcon } from "../../styles";
import {
  CalendarIcon,
  ContainerNumber,
  RefreshIcon,
  Information,
  MainDiv,
  ContainerBox,
  HiddenBoxComponent,
  HiddenBoxWrapper,
  useStyles,
  SecondInformation,
} from "./styles";

const boxImg = require("../../../../../assets/img/air-tracking-box.svg");
const containerImg = require("../../../../../assets/img/container-black.svg");

interface Props {
  shipmentHasTracking?: boolean;
  event?: ProgressBarContainerEvent;
  containerName?: String;
  grossWeight?: string;
  toggle: boolean;
  setToggle?: () => void;
  containerSize?: String;
  isAirTracking?: boolean;
}

const EventHeader = ({
  shipmentHasTracking = true,
  event,
  containerName,
  toggle,
  setToggle,
  containerSize,
  grossWeight,
  isAirTracking,
}: Props) => {
  const { t: translate } = useTranslation();
  const renderArrowByCollapse = () => {
    if (setToggle) {
      if (!toggle) {
        return <IoIosArrowDown color="#475467" size={GridConstants.defaultRowActionSize} />;
      }

      return <IoIosArrowUp color="#475467" size={GridConstants.defaultRowActionSize} />;
    }

    return null;
  };

  const classes = useStyles();
  const measurementWeight = getWeightMeasurement();

  const isGrossWeightValid = (grossWeight?: string) => {
    if (grossWeight && grossWeight !== null && !Number.isNaN(grossWeight)) return true;

    return false;
  };

  return (
    <MainDiv canClickIt={!!setToggle} onClick={() => setToggle?.()}>
      <HiddenBoxComponent
        flexDirection={"row"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className={classes.containerImg}
      >
        <img src={isAirTracking ? boxImg : containerImg} />
      </HiddenBoxComponent>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={12}>
          <ContainerBox>
            <HiddenBoxWrapper
              flexDirection={"row"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <img src={isAirTracking ? boxImg : containerImg} />
            </HiddenBoxWrapper>
            <Box
              flexDirection={"column"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"flex-start"}
            >
              <ContainerNumber>{containerName}</ContainerNumber>

              <Box
                flexDirection={"row"}
                display={"flex"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                gap={4}
              >
                {containerSize && <SecondInformation>{containerSize}</SecondInformation>}
                {containerSize && isGrossWeightValid(grossWeight) && (
                  <SecondInformation>{"-"}</SecondInformation>
                )}
                {isGrossWeightValid(grossWeight) && (
                  <SecondInformation>
                    {handleGetConvertValue(Number(grossWeight), measurementWeight?.code)}
                    {measurementWeight?.code}
                  </SecondInformation>
                )}
              </Box>
            </Box>
          </ContainerBox>
        </Grid>
        {shipmentHasTracking ? (
          <Grid item container xs={12} spacing={2}>
            <Grid item className={classes.headerInfoAlign}>
              <RefreshIcon className={classes.icon} />
              <Information>
                {translate(event?.eventTypeDescription || translate("waitingForUpdate"))}
              </Information>
            </Grid>
            <Grid item className={classes.headerInfoAlign}>
              <LocationIcon size={16} />
              <Information>{event?.eventLocationName || translate("waitingForUpdate")}</Information>
            </Grid>
            <Grid item className={classes.headerInfoAlign}>
              <CalendarIcon size={16} />
              <Information>{event?.nextEventDateTime || translate("waitingForUpdate")}</Information>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Information>{translate("eventsUnavailable")}</Information>
          </Grid>
        )}
      </Grid>
      <Box flexDirection={"row"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
        {renderArrowByCollapse()}
      </Box>
    </MainDiv>
  );
};

export default EventHeader;
